import { Search } from '@material-ui/icons';
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { mobile } from "../responsive";

const Container = styled.div`
    height: 100%;
    ${mobile({ height: "50px" })}
`;

const Wrapper = styled.div`
    padding: 10px 20px;
    display: flex;
    align-item: center;
    justify-content: space-between;
    ${mobile({ padding: "10px 0px" })}
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
`;

const Language = styled.span`
    font-size: 14px;
    cursor: pointer;
    ${mobile({ display: "none" })}
`

const SearchContainer = styled.div`
    border: 0.5px solid lightgray;
    display: flex;
    align-items: center;
    margin-left: 25px;
    padding: 5px;
    ${mobile({ marginLeft: "20px" })}
`;

const Input = styled.input`
    border: none;
    ${mobile({ width: "50px" })}
`;

const Center = styled.div`
    flex: 1;
    text-align: center;
`;

const Logo = styled.h1`
    font-weight: 900;
    color: #0039a6;
    ${mobile({ fontSize: "24px" })}
`
const Right = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${mobile({ marginRight: "1.5px" })}
`;

const MenuItem = styled.div`
    font-size: 14px;
    cursor: pointer;
    margin-left: 25px;
    ${mobile({ fontSize: "12px", marginLeft: "10px" })}
`

const Navbar = () => {
  return (
    <Container>
        <Wrapper>
            <Left>
                <Language>EN</Language>
                <SearchContainer>
                    <Input/>
                    <Search style={{color:"gray", fontSize: 16}}/>
                </SearchContainer>
            </Left>
            <Center>
                <Logo>ORION RENTAL</Logo>
            </Center>
            <Right>
                
                    <MenuItem><Link to='/' style={{color: 'black', fontWeight: '500'}}>Home</Link></MenuItem>

                    <MenuItem><Link to='/uhaul' style={{color: 'black', fontWeight: '500'}}>U-Haul</Link></MenuItem>

                    <MenuItem><Link to='/catalog' style={{color: 'black', fontWeight: '500'}}>Catalog</Link></MenuItem>
                    <MenuItem><Link to='/propane' style={{color: 'black', fontWeight: '500'}}>Propane</Link></MenuItem>
            </Right>
        </Wrapper>
    </Container>
  )
}

export default Navbar